import React, { ChangeEvent, useState } from "react";

import { useProfile } from "@/customHooks/useProfile";
import { useTranslation } from "next-i18next";

import { SwipeableEdgeDrawer } from "@/components/elements/bottom-drawer-with-edge/BottomDrawerWithEdge";
import { MemoizedTextField } from "@/components/elements/memoized-textfield/MemoizedTextField";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Modal,
  useMediaQuery,
  useTheme
} from "@mui/material";

export const CreateFolderDrawer = ({
  isOpen,
  toggleDrawer
}: any): JSX.Element => {
  const { createFolder } = useProfile();
  const { t } = useTranslation("searchpage");
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));

  const [folderName, setFolderName] = useState<string>("");

  const handleChangeFolderName = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setFolderName(e.target.value);
  };

  const onCloseModal = () => {
    toggleDrawer(false);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await createFolder.mutateAsync({ folderName });
      toggleDrawer(false);
      setFolderName("");
    } catch (e) {
      console.log("Can't remove folder");
    }
  };

  if (isGreaterThanTablet) {
    return (
      <Modal open={isOpen} onClose={onCloseModal}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            // alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#FFFFFF",
            padding: "60px 80px",
            borderRadius: "10px",
            maxWidth: 640,
            width: "100%"
          }}>
          <form action="create-folder" onSubmit={handleSubmit}>
            <MemoizedTextField
              value={folderName}
              onChange={handleChangeFolderName}
              fullWidth
              label={t("favourites.create-folder")}
              placeholder={t("favourites.edit-drawer.input.placeholder")}
              sx={{ mb: 5 }}
            />
            <Box sx={{ display: "flex", gap: "15px" }}>
              <Button
                onClick={() => onCloseModal()}
                startIcon={
                  createFolder.isLoading && <CircularProgress size={20} />
                }
                fullWidth
                sx={{
                  border: "1px solid #42210A"
                }}
                color={"white"}>
                {t("favourites.delete-dialog.cancel")}
              </Button>
              <Button
                type={"submit"}
                startIcon={
                  createFolder.isLoading && <CircularProgress size={20} />
                }
                fullWidth
                color={"green"}>
                {t("favourites.edit-drawer.button")}
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    );
  }

  return (
    <SwipeableEdgeDrawer
      isOpen={isOpen}
      toggleDrawer={toggleDrawer}
      disableGutters>
      <Container sx={{ mb: 4 }}>
        <form action="create-folder" onSubmit={handleSubmit}>
          <MemoizedTextField
            value={folderName}
            onChange={handleChangeFolderName}
            fullWidth
            label={t("favourites.create-folder")}
            placeholder={t("favourites.edit-drawer.input.placeholder")}
            sx={{ mb: 5 }}
          />
          <Button
            type={"submit"}
            startIcon={createFolder.isLoading && <CircularProgress size={20} />}
            fullWidth
            color={"green"}>
            {t("favourites.edit-drawer.button")}
          </Button>
        </form>
      </Container>
    </SwipeableEdgeDrawer>
  );
};
